export default __webpack_public_path__ + "static/media/icn-user-search.aeebc628.svg";